export default __webpack_public_path__ + "static/media/logo.e11f0cc7.png";